export const reviews = [
    {
      "img": "https://lh3.googleusercontent.com/a-/ALV-UjW-ri5QLXyf6265vvlkLZHqGgsnVKNy_u6F3YwRmkc1xSrmnuk=s64-c-rp-mo-br100",
      "name": "Luigi Di Mare",
      "date": "",
      "rating": 5,
      "text": "Excellent service, friendly attitude, and top haircuts. I want to praise Jirka, thank you for the cut. We need more people like you!"
    },
    {
      "img": "https://lh3.googleusercontent.com/a-/ALV-UjVOEKtn9z1_C44n7nzPG8RM0oIbgd8up5ABaWN-0gJ5HsVrCPU=s64-c-rp-mo-br100",
      "name": "Jan Havlíček",
      "date": "",
      "rating": 5,
      "text": "If you want to look great and be satisfied, I recommend visiting. Nowhere else will you feel as good as here."
    },
    {
      "img": "https://lh3.googleusercontent.com/a/ACg8ocKp18LuZAUMV-vgRxP5h0u0ecHBPx9QruSfrd3jSFZgDDvUzx8=s64-c-rp-mo-br100",
      "name": "Petr Volšička",
      "date": "",
      "rating": 5,
      "text": "Above-standard care. Absolute satisfaction. I can only recommend barber Jirka. Thanks again.🫡"
    },
    {
      "img": "https://lh3.googleusercontent.com/a/ACg8ocLyOOhFYWX9uVI0ybJZpwMh6P6uu258W0FlJV5Hb3JgYuHlFA=s64-c-rp-mo-br100",
      "name": "Jan Kadleček",
      "date": "",
      "rating": 5,
      "text": "I was very satisfied, Kačka cut my hair, I can only recommend it, next time I'll come only here 👍😊"
    },
    {
      "img": "https://lh3.googleusercontent.com/a-/ALV-UjWNJhVBLmY8vPduZbtnnANabBDfa90gBtkv_ItBGU9JJv22F3Sjtg=s64-c-rp-mo-ba2-br100",
      "name": "Mateusz Tyč",
      "date": "",
      "rating": 5,
      "text": "Professional and friendly approach, great atmosphere, beautiful results. There's no other option but 5 out of 5."
    },
    {
      "img": "https://lh3.googleusercontent.com/a-/ALV-UjUdLql_WujSpoMv63EwjhLQkMUv2diurxLOdi89fRqbRV6OKnXa=s64-c-rp-mo-br100",
      "name": "PAWLIE POIZN",
      "date": "",
      "rating": 5,
      "text": "Best barbershop in Prague, professional attitude, friendly environment. Maximum satisfaction, I recommend it."
    },
    {
      "img": "https://lh3.googleusercontent.com/a/ACg8ocLzfgTCuHdKW2atnum694w5r6QVdUQO7tTaPxdnanPvXvL9rw=s64-c-rp-mo-br100",
      "name": "Karel Uhlíř",
      "date": "",
      "rating": 5,
      "text": "After trying several different barber shops, I found the right one. Simply awesome from start to finish. Barber Jirka is truly a pro who knows what he's doing and isn't afraid to advise you on your haircut, style, or even choosing cologne. Definitely recommend."
    },
    {
      "img": "https://lh3.googleusercontent.com/a/ACg8ocJxYoa02_ZtRJssVPv9qBOmru6E4LH8KxkKTQFWIkQoE7fb1w=s64-c-rp-mo-br100",
      "name": "Nikita Fesyukov",
      "date": "",
      "rating": 5,
      "text": "I come here regularly and the result is always perfect. Great, friendly service—especially Jirka :) I can only recommend!"
    },
    {
      "img": "https://lh3.googleusercontent.com/a-/ALV-UjU13vg3r6kLwGefP8iQMWC_KSZDXEGsXHBrazhsReU5d3H4KsXu=s64-c-rp-mo-br100",
      "name": "Jan Malík",
      "date": "",
      "rating": 5,
      "text": "I always like coming back here. Pleasant and friendly environment, experienced staff who not only know what they're doing but can also advise you so you feel like a new person after leaving the salon. I definitely recommend!"
    }
  ]

